import { defineStore } from "pinia";
import { createBaseStoreRefactor } from "./baseStoreRefactor";

// Create base store configuration for account leads
const accountLeadsBaseStore = createBaseStoreRefactor({
  endpoint: "/api/v1/account_leads",
  name: "AccountLeadsStoreRefactor",
  objectName: "Aanleiding", // Auto-generates CRUD success messages
  enableCache: true, // Enable caching since leads rarely change
  actionCableChannel: null, // No real-time updates needed
  infiniteLoading: false, // Simple list, no pagination needed
});

export const useAccountLeadsStoreRefactor = defineStore(
  "accountLeadsRefactor",
  {
    ...accountLeadsBaseStore,

    getters: {
      ...accountLeadsBaseStore.getters,

      /**
       * Get all leads (maps to state.data for compatibility)
       */
      leads: (state) => {
        return state.data || [];
      },

      /**
       * Get lead by ID
       */
      getLeadById: (state) => (id) => {
        return state.data.find((lead) => lead.id == id);
      },

      /**
       * Get active leads only (if leads have an active field)
       */
      activeLeads: (state) => {
        return state.data.filter((lead) => lead.active !== false);
      },
    },

    actions: {
      ...accountLeadsBaseStore.actions,

      // All methods including CRUD operations are fully inherited from base store
      // Auto-generated messages use "Aanleiding" from objectName
    },
  },
);
